"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
const operators_1 = require("rxjs/operators");
const file_data_service_1 = require("../file-data.service");
const veflux_1 = require("vasat/dist/src/veflux");
const stream_data_service_1 = require("../stream-data.service");
const keyboard_service_1 = require("../keyboard.service");
class FileListComponent {
    constructor(streamManager, keys, fourD, cdr) {
        this.streamManager = streamManager;
        this.keys = keys;
        this.fourD = fourD;
        this.cdr = cdr;
        this._files = [];
        this._selectedFiles = [];
        this._subs = [];
        this.change = new core_1.EventEmitter();
    }
    set selectedFolder(s) {
        this._selectedFolder = s;
    }
    set selectedFiles(s) {
        this._selectedFilesStore = s;
    }
    set files(s) {
        this._filesStore = s;
    }
    ngOnInit() {
        this._subs.push(this._selectedFolder.events.subscribe(s => {
            if (s.event == 'ADD') {
                var baseQ = this.fourD.V
                    .searchByObject(_4d_mapper_1.Dataset)
                    .limit(40)
                    .useCache(true);
                if (s.item.ref instanceof _4d_mapper_1.Account)
                    baseQ = baseQ.equals('folder', 'null').equals('account', s.item.ref.id);
                else
                    baseQ = baseQ.equals('folder', s.item.ref.id);
                baseQ.queryObservable()
                    .subscribe(s => {
                    this._filesStore.values = s.items;
                });
            }
            else if (s.event == 'REMOVE') {
                this._filesStore.values = [];
            }
        }));
        this._subs.push(this._filesStore.state.subscribe(f => {
            this._files = f;
            this.cdr.detectChanges();
        }));
        this._subs.push(this._selectedFilesStore.state.subscribe(f => {
            this._selectedFiles = f;
            this.cdr.detectChanges();
        }));
        this._subs.push(this.streamManager.fileEvents.filter(ev => ev.item.folder == this._selectedFolder.value.ref).subscribe(ev => {
            if (ev.event == 'uploading')
                this._filesStore.set(ev.item);
            else if (ev.event == 'REMOVE')
                this._filesStore.remove(ev.item);
            this.cdr.detectChanges();
        }));
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
    }
    changed(ev) {
        this.change.emit(ev);
        if (!this.disableSelection && ev.event == 'selected')
            if (this.keys.isCtrl) {
                var exists = this._selectedFilesStore.contains(ev.item);
                if (exists)
                    this._selectedFilesStore.remove(ev.item);
                else
                    this._selectedFilesStore.add(ev.item);
            }
            else
                this._selectedFilesStore.values = [ev.item];
    }
}
exports.FileListComponent = FileListComponent;
class FileNode {
    constructor(stream, cdr) {
        this.stream = stream;
        this.cdr = cdr;
        this.selected = new veflux_1.ArrayStore(file_data_service_1.FileEvent);
        this.change = new core_1.EventEmitter();
        this.subs = [];
    }
    ngOnInit() {
        this.canPlot = this.file['canPlot'];
        this.subs.push(this.stream.fileEvents.pipe(operators_1.filter(ev => ev.item == this.file)).subscribe(ev => {
            if (ev.event == 'uploading')
                this.isUploading = true;
            else if (ev.event == 'upload_finished')
                this.isUploading = false;
            else if (ev.event == 'processing')
                this.isProcessing = true;
            else if (ev.event == 'processing_finished')
                this.isProcessing = false;
            this.cdr.detectChanges();
        }));
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
    clicked() {
        this.change.emit(new file_data_service_1.FileEvent(this.file, 'selected'));
    }
}
exports.FileNode = FileNode;
